import React, {Component} from "react";
import SimpleInput from "../../../../../modules/SimpleInput";
import SimpleDDL from "../../../../../modules/SimpleDDL";
import {mapToObjectDDL} from "../../../../common/mapper";

class DataUnitTab extends Component {
    render() {
        return (
            <div className="grid grid-2x grid-mobile-none gap-15px" style={{alignItems: "center"}}>
                <div id="unit_grid-1">
                    <h4>Info Unit</h4>
                    <SimpleDDL
                        id="select_options_kode_varian"
                        name="kodeVarian"
                        label="Kode Varian"
                        box="search"
                        readOnly
                        value={mapToObjectDDL(
                            this.props.data?.dataVariant?.kodeVariant,
                            this.props.data?.dataVariant?.kodeVariant
                        )}
                    />
                    <p>Nama Varian: {this.props.data?.dataVariant?.namaVariant}</p>
                    <p>Tipe: {this.props.data?.dataVariant?.typeDTO?.typeName}</p>
                    <p>Series: {this.props.data?.dataVariant?.typeDTO?.idSeries}</p>
                    <SimpleDDL
                        id="select_options_kode_warna"
                        name="kodeWarna"
                        label="Kode Warna"
                        box="search"
                        readOnly
                        value={mapToObjectDDL(
                            this.props.data?.dataWarna?.kodeWarna,
                            this.props.data?.dataWarna?.kodeWarna
                        )}
                    />
                    <p>Nama Warna: {this.props.data?.dataWarna?.namaWarnaKomersil}</p>
                </div>
                <div id="unit_grid-2">
                    <SimpleInput
                        id="input_text_no_mesin"
                        name="noMesin"
                        label="No Mesin"
                        readOnly
                        value={this.props.data?.engineNumber}
                    />
                    <SimpleInput
                        id="input_text_no_rangka"
                        name="noRangka"
                        label="No Rangka"
                        readOnly
                        value={this.props.data?.frameNumber}
                    />
                </div>
            </div>
        );
    }
}

export default DataUnitTab;
